import { DataService } from './../../../services/data/data.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IContractData, IHidePlanPrice, IOfferDetails } from '../../../interfaces/IJob';
import { DEDUCTIBLE_TEXT } from '../../pages/my-plan/my-plan.constants';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { MONTH_FREE } from '../../../utils/constants';
import { Subject, takeUntil } from 'rxjs';
import { IFeatureFlag } from '../../../interfaces/IFeatureFlags';
import { FEATURES_CONSTANT } from '../../../utils/features.constant';

@Component({
  selector: 'app-plan-cost',
  templateUrl: './plan-cost.component.html',
  styleUrl: './plan-cost.component.scss'
})
export class PlanCostComponent implements OnInit, OnDestroy {
  cleaner$: Subject<void> = new Subject();
  contractData: IContractData | null = null;
  isOfferApplicable: boolean = false;
  deductibleText = DEDUCTIBLE_TEXT;
  isPlanCe: boolean = false;
  isPlanBYOP: boolean = false;
  isArchMiYearZero: boolean = false;
  isPlanBillMechCodeEmbed:boolean = false;
  hidePlanPrice: IHidePlanPrice | null = null;
  screenWidth: number = 0;
  collapsed = false;
  isPlanBillMechCodeBillClient:boolean = false;
  constructor(private data:DataService, private utilService: UtilitiesService){}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.data.contractData$.pipe(takeUntil(this.cleaner$)).subscribe((contract) => {
      if (contract) {
        this.contractData = contract;
        const { baseContract } = contract;
        this.isOfferApplicable = baseContract.offerDetails ? this.checkOfferValid(baseContract.offerDetails) : false;
        this.isPlanCe = this.utilService.isPlanCE(baseContract.coverageGroup);
        this.isPlanBYOP = this.utilService.isPlanBYOP(baseContract.coverageGroup);
        this.hidePlanPrice = baseContract.hidePlanPrice;
        this.isArchMiYearZero = this.utilService.isArchMIYearZero(baseContract);
        this.isPlanBillMechCodeEmbed = this.utilService.isPlanBillMechCodeEmbed(baseContract?.billMechCode);
        const featureFlags = this.data.featureFlags$.getValue();
        const moenAndH4hFeatureFlag = featureFlags?.features?.find((feature: IFeatureFlag) => feature.feature === FEATURES_CONSTANT.MOENANDH4H)?.flag || false;
        this.isPlanBillMechCodeBillClient = moenAndH4hFeatureFlag && this.utilService.isPlanBillMechCodeBillClient(baseContract.billMechCode);  
      }
    });

    this.utilService.screenWidth$.pipe(takeUntil(this.cleaner$)).subscribe(width => {
      const newWidth = width;
      // If screen crosses from <= 992px to > 992px, force expand
      if (this.screenWidth <= 992 && newWidth > 992) {
        if (this.collapsed) {
          this.collapsed = false; // Auto-expand only if user had it collapsed
        }
      }
      this.screenWidth = newWidth;
    });
  }

  checkOfferValid(offer: IOfferDetails): boolean {
    return offer && offer.offerType != null && offer.offerType.toUpperCase() !== MONTH_FREE;
  }

  get totalPriceYear(): string {
    const totalPremium = parseFloat(this.contractData?.baseContract?.totalPremiumPrice || '0');
    const salesTax = parseFloat(this.contractData?.baseContract?.salesTax || '0');
    return (totalPremium + salesTax).toFixed(2);
  }

  getPaymentText(): string {
    if (this.hidePlanPrice?.clientName === 'ALLSTATE') {
      return `This policy is being paid by ${this.hidePlanPrice?.clientName}.`;
    } else  {
      return `This policy is being paid for by ${this.contractData?.baseContract?.clientCorporateName}.`;
    }
  }

  get showPlanCost(): boolean {
    return !this.hidePlanPrice?.hideFlag && !this.isArchMiYearZero && !this.isPlanBillMechCodeEmbed && !this.isPlanBillMechCodeBillClient;
}

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
